import { createAsyncThunk } from "@reduxjs/toolkit";
import client from "../../../app/core/client-http/client";
import { endpoint } from "../../../utils/constants/endpoint";


export const splitDocument = createAsyncThunk(
    "splitDocument/split",
    async ({ Id, Breaks }, thunkAPI) => {
        const response = await client.post(
            endpoint.ADMIN_DOCUMENT.DOCUMENTS + "/" + Id + "/split?breaks=" + Breaks
        );

        if (response.ok) {
            return thunkAPI.fulfillWithValue(response.data);
        } else {
            return thunkAPI.rejectWithValue();
        }
    }
);

